import {Component, OnInit} from '@angular/core';
import {AppDialogComponent} from "../../common/app-dialog/app-dialog.component";
import {
    FormItemTextComponent
} from "../../common/forms/form-item-text/form-item-text.component";
import {
    FormActionButtonsComponent
} from "../../common/forms/form-action-buttons/form-action-btns.component";
import {
    FormButtonComponent
} from "../../common/forms/form-button/form-button.component";
import {AppAlertService} from "../../core";

@Component({
    selector: 'alert-dialog',
    standalone: true,
    imports: [
        AppDialogComponent,
        FormItemTextComponent,
        FormActionButtonsComponent,
        FormButtonComponent
    ],
    templateUrl: './alert-dialog.component.html',
    styleUrl: './alert-dialog.component.scss'
})
export class AlertDialogComponent implements OnInit {
    message: string = '';
    messages: string[] = [];

    constructor(public appAlert: AppAlertService) {
    }

    ngOnInit() {
        const alertDialog = this.appAlert.alertDialog;
        if (!alertDialog) {
            return;
        }

        if (Array.isArray(alertDialog.message)) {
            this.messages = alertDialog.message;
        } else {
            this.message = alertDialog.message;
        }
    }
}
